
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// $(document).ready(function(){
//     $('[data-toggle="tooltip"]').tooltip();
// });

$(function () {
    $('[data-toggle="tooltip"]').tooltip({
                    boundary: "window",
                    container: "body"
        }
    )
})

// $('[data-toggle="tooltip"]').tooltip({
//     animated: 'fade',
//     placement: 'top',
//     html: true
// });

$('.open-modal').on('click', function(e){
    e.preventDefault();
    $('#modal').modal('show').find('.modal-content').load($(this).attr('href'));
});

$("#inventory_menu_link").on('click', function(e){
    e.preventDefault();
    if($('.inventory_menu_item').css('display') === 'none'){
        $('.inventory_menu_item').css('display','block')
    }else{
        $('.inventory_menu_item').css('display','none')
    }
});






//
// window.Vue = require('vue');
//
// /**
//  * Next, we will create a fresh Vue application instance and attach it to
//  * the page. Then, you may begin adding components to this application
//  * or customize the JavaScript scaffolding to fit your unique needs.
//  */
//
// Vue.component('example', require('./components/Example.vue'));
//
// const app = new Vue({
//     el: '#app'
// });


































// WEBPACK FOOTER //
// ./resources/assets/js/app.js